<capra-icon *ngIf="icon"
  class="icon"
  data-test="capra-banner-icon"
  width="32px"
  height="32px"
  [icon]="icon"
></capra-icon>

<div class="content"
  data-test="capra-banner-content"
>
  <h3 *ngIf="header"
    class="header"
    data-test="capra-banner-header"
  >
    {{ header }}
  </h3>
  <p *ngIf="text"
    class="text"
    data-test="capra-banner-text"
  >
    {{ text }}
  </p>

  <p *ngIf="warningMessage"
    class="warning-message"
    data-test="capra-banner-text"
  >
    <span class="warning-message weighted">{{ warningMessage }}</span> {{ tipMessage }}
  </p>

  <ng-container *ngIf="!header && !text">
    <ng-content select="[capra-banner-content]"></ng-content>
  </ng-container>
</div>

<div class="actions"
  data-test="capra-banner-actions"
>
  <ng-content select="[capra-banner-actions]"></ng-content>
</div>
